"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeoTargetExclusionsToJSON = exports.GeoTargetExclusionsFromJSONTyped = exports.GeoTargetExclusionsFromJSON = exports.instanceOfGeoTargetExclusions = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the GeoTargetExclusions interface.
 */
function instanceOfGeoTargetExclusions(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGeoTargetExclusions = instanceOfGeoTargetExclusions;
function GeoTargetExclusionsFromJSON(json) {
    return GeoTargetExclusionsFromJSONTyped(json, false);
}
exports.GeoTargetExclusionsFromJSON = GeoTargetExclusionsFromJSON;
function GeoTargetExclusionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCodeExclusions': !(0, runtime_1.exists)(json, 'country_code_exclusions') ? undefined : json['country_code_exclusions'],
        'cityIdsExclusions': !(0, runtime_1.exists)(json, 'city_ids_exclusions') ? undefined : json['city_ids_exclusions'],
        'dmaIdsExclusions': !(0, runtime_1.exists)(json, 'dma_ids_exclusions') ? undefined : json['dma_ids_exclusions'],
        'postalCodeIdsExclusions': !(0, runtime_1.exists)(json, 'postal_code_ids_exclusions') ? undefined : json['postal_code_ids_exclusions'],
        'regionIdsExclusions': !(0, runtime_1.exists)(json, 'region_ids_exclusions') ? undefined : json['region_ids_exclusions'],
    };
}
exports.GeoTargetExclusionsFromJSONTyped = GeoTargetExclusionsFromJSONTyped;
function GeoTargetExclusionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country_code_exclusions': value.countryCodeExclusions,
        'city_ids_exclusions': value.cityIdsExclusions === undefined ? undefined : Array.from(value.cityIdsExclusions),
        'dma_ids_exclusions': value.dmaIdsExclusions === undefined ? undefined : Array.from(value.dmaIdsExclusions),
        'postal_code_ids_exclusions': value.postalCodeIdsExclusions === undefined ? undefined : Array.from(value.postalCodeIdsExclusions),
        'region_ids_exclusions': value.regionIdsExclusions === undefined ? undefined : Array.from(value.regionIdsExclusions),
    };
}
exports.GeoTargetExclusionsToJSON = GeoTargetExclusionsToJSON;
